/*
 * @Author: your name
 * @Date: 2021-06-22 15:23:31
 * @LastEditTime: 2021-06-22 15:24:15
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \ecfc-oms-facade\src\common\utils\validate.js
 */
/**
 * @param {string} path
 * @returns {Boolean}
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}




// WEBPACK FOOTER //
// ./src/common/utils/validate.js